module.exports = __webpack_public_path__ + "media/images/squadBet__iconClearSwap-7cf94b7adb00774ffaa92f6f4e94ef63.png";